import { useRef } from 'react';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import { Box, Input, Text, Flex, InputGroup, InputLeftElement, Button, InputRightElement } from '@chakra-ui/react';
import OutsideClickHandler from 'react-outside-click-handler';

import './styles.scss';
import { shortMonthLists } from '@helpers/const';
import { ArrowIcon, CalendarIcon2 } from '@assets/icons';

export default function DatePickerComp({
    placeholder = 'Pilih Tanggal',
    width = '100%',
    label = 'Date',
    isRange = false,
    isMultiple = false,
    value,
    onChange,
    minDate,
    maxDate,
    isIconRight = false,
    helperText = '',
    isInvalid = false,
    isDimBg = false,
}) {
    const datePickerRef = useRef(null);
    const displayValue = (() => {
        if (!value || (Array.isArray(value) && value.length === 0)) return '';
        if (Array.isArray(value)) {
            if (isRange) {
                return value.length === 2 ? `${value[0]} - ${value[1]}` : '';
            }
            if (isMultiple) {
                return value.map((v) => v).join(', ');
            }
        }
        return value;
    })();

    const bg = isDimBg && displayValue ? 'semantic.200' : 'semantic.100';

    return (
        <Box width={width}>
            <Text mb={2} fontSize={'14px'} fontWeight={'700'}>
                {label}
            </Text>
            <OutsideClickHandler onOutsideClick={() => datePickerRef.current?.closeCalendar()}>
                <DatePicker
                    ref={datePickerRef}
                    value={value}
                    showOtherDays
                    range={isRange}
                    minDate={minDate}
                    maxDate={maxDate}
                    onChange={onChange}
                    multiple={isMultiple}
                    weekStartDayIndex={1}
                    monthYearSeparator=" "
                    highlightToday={false}
                    months={shortMonthLists}
                    calendarPosition="bottom"
                    renderButton={(direction, handleClick) => (
                        <button onClick={handleClick}>
                            <ArrowIcon isRight={direction === 'right'} />
                        </button>
                    )}
                    render={(_, openCalendar) => (
                        <Flex align="center" gap={2} onClick={openCalendar}>
                            <InputGroup>
                                {isIconRight ? (
                                    <InputRightElement pointerEvents="none">
                                        <CalendarIcon2 />
                                    </InputRightElement>
                                ) : (
                                    <InputLeftElement pointerEvents="none">
                                        <CalendarIcon2 />
                                    </InputLeftElement>
                                )}
                                <Input
                                    isReadOnly
                                    width={width}
                                    placeholder={placeholder}
                                    value={displayValue}
                                    bg={bg}
                                    cursor={'pointer'}
                                    isInvalid={isInvalid}
                                    _invalid={{
                                        borderColor: 'danger.500',
                                    }}
                                />
                            </InputGroup>
                        </Flex>
                    )}
                    plugins={[
                        <SelectTodayDate
                            onClick={() => {
                                onChange(new DateObject());
                                datePickerRef.current?.closeCalendar();
                            }}
                            position="bottom"
                        />,
                    ]}
                />

                {helperText && (
                    <Text fontSize={'10px'} mt={'8px'} color={isInvalid ? 'danger.500' : 'semantic.500'}>
                        {helperText}
                    </Text>
                )}
            </OutsideClickHandler>
        </Box>
    );
}

const SelectTodayDate = ({ onClick }) => {
    return (
        <Box className="select-today">
            <Button onClick={onClick} variant={'text'} width={'full'}>
                Today
            </Button>
        </Box>
    );
};
